



















































import Vue from 'vue';
import { gsap } from 'gsap';
import { mapState } from 'vuex';
import PresenceInfo from './components/PresenceInfo.vue';
import OtherInfo from './components/OtherInfo.vue';

export default Vue.extend({
  components: {
    PresenceInfo,
    OtherInfo,
  },
  data() {
    return {
      yes: 0 as number,
      no: 0 as number,
    };
  },
  props: {
    delegatesData: Array,
    info: Object,
    rulesData: Object,
  },
  computed: {
    ...mapState({
      width: (state: any) => state.Global.widthWindow,
    }),
    vote(): boolean {
      if (this.no > this.yes) {
        return true;
      }
      return false;
    },
    left(): number {
      return this.info['Total Present'] - (this.yes + this.no);
    },
  },
  methods: {
    swipeHandler(direction: string): void {
      const swipe: HTMLElement | null = document.querySelector('.swipe:first-child');
      const swipe2: HTMLElement | null = document.querySelector('.swipe:last-child');
      if (direction === 'left') {
        if (swipe2 && swipe2.classList.contains('active')) {
          gsap.set(swipe, {
            x: '100%',
          });
        } else {
          gsap.set(swipe2, {
            x: '0',
          });
        }
        gsap.to('.swipe', {
          x: '-=100%',
        });
      } else if (direction === 'right') {
        if (swipe2 && swipe2.classList.contains('active')) {
          gsap.set(swipe, {
            x: '-100%',
          });
        } else {
          gsap.set(swipe2, {
            x: '-200%',
          });
        }
        gsap.to('.swipe', {
          x: '+=100%',
        });
      }
      if (swipe) swipe.classList.toggle('active');
      if (swipe2) swipe2.classList.toggle('active');
    },
  },
  watch: {
    left() {
      if (this.vote && this.no !== this.yes) {
        (this.$refs.indicator as HTMLElement).style.cssText = 'opacity: 1; left: 55%; background-color: rgba(255,95,95,0.2);';
      } else if (!this.vote && this.no !== this.yes) {
        (this.$refs.indicator as HTMLElement).style.cssText = 'opacity: 1; left: 5%; background-color: rgba(95,120,255,0.2);';
      } else if (this.no === this.yes) {
        (this.$refs.indicator as HTMLElement).style.cssText = 'opacity: 0; left: 30%; background-color: rgba(255,255,255,0.2);';
      }
    },
  },
});
